module.exports = __webpack_public_path__ + "img/02-min.01b9202d.png";